import { parseSignupIntent, parseSignupPlan } from '@repo/common';
export const SIGNUP_INTENT_STORAGE_KEY = 'starthub:signup_intent';
/** A saved intent outlives an email verification or a return visit, but not a week. */
export const SIGNUP_INTENT_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
function parseStoredSignupIntent(raw, now) {
    if (!raw)
        return undefined;
    try {
        const parsed = JSON.parse(raw);
        if (typeof parsed !== 'object' || parsed === null)
            return undefined;
        const savedAt = Reflect.get(parsed, 'savedAt');
        if (typeof savedAt !== 'number' || savedAt > now || now - savedAt >= SIGNUP_INTENT_MAX_AGE_MS)
            return undefined;
        const intent = parseSignupIntent(String(Reflect.get(parsed, 'intent')));
        if (!intent)
            return undefined;
        const plan = intent === 'premium' ? parseSignupPlan(String(Reflect.get(parsed, 'plan'))) : undefined;
        return plan ? { intent, plan } : { intent };
    }
    catch {
        return undefined;
    }
}
/**
 * Saves the visitor's intent in this origin's localStorage. Routing intent is functional, not marketing data, so it
 * is kept regardless of cookie consent; it survives email verification, OAuth round trips and reloads, which all
 * drop the query string.
 */
export function saveSignupIntent(selection) {
    try {
        localStorage.setItem(SIGNUP_INTENT_STORAGE_KEY, JSON.stringify({ intent: selection.intent, plan: selection.plan, savedAt: Date.now() }));
    }
    catch {
        // Storage can be blocked; the URL still carries the intent for this page.
    }
}
export function readSignupIntent() {
    try {
        const raw = localStorage.getItem(SIGNUP_INTENT_STORAGE_KEY);
        const selection = parseStoredSignupIntent(raw, Date.now());
        if (!selection && raw !== null)
            localStorage.removeItem(SIGNUP_INTENT_STORAGE_KEY);
        return selection;
    }
    catch {
        return undefined;
    }
}
/** Routing is done once checkout opens or the dashboard is reached, so a later visit starts fresh. */
export function clearSignupIntent() {
    try {
        localStorage.removeItem(SIGNUP_INTENT_STORAGE_KEY);
    }
    catch {
        // Storage can be blocked.
    }
}
//# sourceMappingURL=signup-intent-storage.js.map